// react
// dependencies
import { List } from "immutable";
import PropTypes from "prop-types";
import React from "react";

import Icon from "../../../../../components/Icon";
import Spinner from "../../../../../components/Spinner";
// components
import File from "./File";

export default class Folder extends React.Component {
	static propTypes = {
		isOpen: PropTypes.bool.isRequired,
		isRequesting: PropTypes.bool.isRequired,
		onClick: PropTypes.func.isRequired,
		onFileClick: PropTypes.func.isRequired,
		label: PropTypes.string.isRequired,
		id: PropTypes.string.isRequired,
		files: PropTypes.instanceOf(List).isRequired,
	};

	handleClick = (documentID) => {
		this.props.onFileClick(documentID);
	};

	render() {
		const { id, label, onClick, isOpen, files, isRequesting } = this.props;

		const iconName = isOpen ? ["far", "folder-open"] : ["far", "folder"];

		return (
			<div className={`folder ${isOpen ? "is-open" : "is-closed"}`}>
				<div className="folder-container" onClick={() => onClick(id)}>
					<Icon type="fa5" name={iconName} size="lg" />
					<div className="folder-name">{label}</div>

					{isRequesting ? (
						<div style={{ position: "absolute", top: 7, right: 5 }}>
							<Spinner size={16} />
						</div>
					) : (
						""
					)}
				</div>

				{isOpen ? (
					<div className="files-list">
						{files.map((file) => (
							<File
								key={file.get("id")}
								id={file.get("id")}
								name={file.get("name")}
								onClick={this.handleClick}
							/>
						))}
					</div>
				) : (
					""
				)}
			</div>
		);
	}
}
